import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c2d49d5")

_pushScopeId("data-v-4c2d49d5")
const _hoisted_1 = /*#__PURE__*/_createVNode("h2", { "data-cy": "PayPortal.DeferPayment.Heading" }, "You have chosen to pay later.", -1)
const _hoisted_2 = { "data-cy": "PayPortal.DeferPayment.Expiry" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("You can obtain your full license at any time by going to your user profile and clicking the "),
  /*#__PURE__*/_createVNode("b", null, "Complete payment"),
  /*#__PURE__*/_createTextVNode(" button.")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "If your temporary license expires, don't worry—we'll keep all your work saved so you can still complete payment afterward and continue.", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("h2", null, "Working on it...", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "form-horizontal narrower" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, "We'll send you an email to the following address with these details.", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, "You can use a different address.", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  for: "emailAddress",
  class: "col-sm-2 control-label"
}, "Email", -1)
const _hoisted_14 = { class: "col-sm-10" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { id: "buttons" }
_popScopeId()

import { DeferredOption, Backend, ContentAndStudent, Failure, EmailValues } from '@/modules/backend';
import { ref, useContext } from 'vue';
import { prettyDate } from '@/modules/frontend';



export default _defineComponent({
  expose: [],
  props: {
    deferred: { type: null, required: true },
    contentAndStudent: { type: null, required: true },
    emailValues: { type: null, required: true }
  } as unknown as undefined,
  emits: ['other-options', 'success', 'error'],
  setup(__props: {
	deferred: DeferredOption
	contentAndStudent: ContentAndStudent
	emailValues: EmailValues
}, { emit }) {

const props = __props





let waitingForBackend = ref(false)
let emailValues = ref({ ...props.emailValues })

async function deferPayment() {
	
	waitingForBackend.value = true

	try {
		const result = await Backend.deferPayment(props.contentAndStudent, emailValues.value)

		if (result instanceof Failure) {
			// This endpoint does not have any custom errors.
			console.error("Call to backend.deferPayment failed.")
			emit('error')
		} else {
			emit('success')
		}

	} catch (e: unknown) {
		console.error("Call to backend.deferPayment failed: " + e)
		emit('error')
	}

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("p", _hoisted_2, "We'll give you a temporary license which will expire on " + _toDisplayString(_unref(prettyDate)(__props.deferred.expiry)) + ".", 1),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    (_unref(waitingForBackend))
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _hoisted_7
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _createVNode("div", _hoisted_14, [
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  id: "emailAddress",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(emailValues).studentEmailAddress = $event)),
                  "data-cy": "PayPortal.DeferPayment.EmailAddressInput"
                }, null, 512), [
                  [_vModelText, _unref(emailValues).studentEmailAddress]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-default",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('other-options'))),
                  "data-cy": "PayPortal.DeferPayment.OtherOptionsButton"
                }, "Other options"),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-primary",
                  onClick: deferPayment,
                  "data-cy": "PayPortal.DeferPayment.Button"
                }, "Pay later")
              ])
            ])
          ])
        ]))
  ], 64))
}
}

})